import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../../../../models/questions/question.model';
import {UnitHouseModel} from '../../../../../models/questions/subModels/unitHouse.model';
import {Enums} from '../../../../../models/extensions/enums';

@Component({
  selector: 'app-evo-unit-house',
  templateUrl: './evo-unit-house.component.html',
  styleUrls: ['./evo-unit-house.component.css']
})
export class EvoUnitHouseComponent implements OnInit {

  QuestionModel = QuestionModel;
  @Input() question: QuestionModel = new UnitHouseModel();

  constructor() { }

  ngOnInit() {
  }

  castedQuestion(): UnitHouseModel {

    return <UnitHouseModel>this.question;
  }

  showQuestion(): boolean {

    if (this.question) {
      if (this.question.subCategory === Enums.QuestionSubcategories.unitHouse) {
        return true;
      }
    }

    return false;
  }

  questionString(): string {

    return '';
  }

}
